import React from "react";
export const DashboardPage = () => {
  return <div>Dashboard Page</div>;
};
